import React, { Fragment, useState } from "react";
import Header2 from "../../components/Header2/Header2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/software-company-components/Footer/Footer";
import SEO from "../../components/SEO";
 import TestimonialOne from "../../components/software-company-components/Testimonial/Testimonial";

function Testimonial() {
  return (
    <div>
         <Fragment>
        <SEO
            title=""
            description=""
            url="https://www.ufsnetworks.com/testimonial"
            image="https://texora.s3.ap-south-1.amazonaws.com/ufs_logo.jpg"
            canonicalUrl="https://www.ufsnetworks.com/testimonial"
        />
        <Header2 />
        <main>
            <PageTitle
            pageTitle={"Real Experiences from Our Valued Customers"}
            pagesub={"Testimonial"}
            pageTop={""}
            />
            </main>
     <div className="container-fluid">
     <TestimonialOne/>
     </div>
      
      <Footer/>
      <Scrollbar />
      </Fragment>
    </div>
  )
}

export default Testimonial
